import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  Line,
  ComposedChart,
} from "recharts";
import AdminTable from "../Components/AdminTable";
import AddNewUserSuccess from "../Components/AddNewUserSuccess";
import AddNewUserModal from "../Components/AddNewUserModal";
import FilterICon from "../Assets/Icons/filterIcon.svg";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import AiTeamDropDown from "../Components/AiTeamDropDown";
import AdminDropDown from "../Components/AdminDropDown";

const chartOneData = [
  {
    name: "Team 1",
    "Number of Weeks": 25,
  },
  {
    name: "Team 2",
    "Number of Weeks": 35,
  },
  {
    name: "Team 3",
    "Number of Weeks": 45,
  },
  {
    name: "Team 4",
    "Number of Weeks": 23,
  },
  {
    name: "Team 5",
    "Number of Weeks": 45,
  },
  {
    name: "Team 6",
    "Number of Weeks": 20,
  },
  {
    name: "Team 7",
    "Number of Weeks": 26,
  },
];

const chartTwoData = [
  {
    name: "Team 1",
    Workload: 80,
    design: 233,
  },
  {
    name: "Team 2",
    Workload: 100,
    design: 200,
  },
  {
    name: "Team 3",
    Workload: 50,
    design: 254,
  },
  {
    name: "Team 4",
    Workload: 70,
    design: 275,
  },
  {
    name: "Team 5",
    Workload: 82,
    design: 285,
  },
  {
    name: "Team 6",
    Workload: 80,
    design: 275,
  },
];

const overViewArr = [
  {
    count: "5.1K",
    label: "Risk and Compliance",
    stats: 10,
  },
  {
    count: "1.2K",
    label: "Sales",
    stats: 10,
  },
  {
    count: "1.3K",
    label: "R&D",
    stats: 10,
  },
  {
    count: "125",
    label: "Marketing",
    stats: 10,
  },
  {
    count: "808",
    label: "Chemistry",
    stats: 10,
  },
  {
    count: "789",
    label: "Customer Analytics",
    stats: 10,
  },
  {
    count: "123",
    label: "Technical Writing",
    stats: 10,
  },
  {
    count: "78",
    label: "Market Research",
    stats: 10,
  },
  {
    count: "687",
    label: "Social Sciences",
    stats: 10,
  },
  {
    count: "78",
    label: "Due Diligence",
    stats: 10,
  },
];
const demographicsArr = [
  {
    count: "4.1K",
    label: "Total Teams",
    stats: 10,
  },
  {
    count: "163.4K",
    label: "Total Members",
    stats: 10,
  },
  {
    count: "163.4k",
    label: "Total Views",
    stats: 10,
  },
  {
    count: "808",
    label: "Unique Views",
    stats: 10,
  },
];
const industryArr = [
  {
    count: "5.1k",
    label: "Aerospace",
    stats: 10,
  },
  {
    count: "1.2k",
    label: "Agriculture",
    stats: 10,
  },
  {
    count: "1.3k",
    label: "Automotive",
    stats: 10,
  },
  {
    count: "125",
    label: "Chemical",
    stats: 10,
  },
  {
    count: "808",
    label: "Oil and Gas",
    stats: 10,
  },
  {
    count: "789",
    label: "Consumer Goods and Retail",
    stats: 10,
  },
  {
    count: "123",
    label: "Education",
    stats: 10,
  },
  {
    count: "78",
    label: "Energy and Utility",
    stats: 10,
  },
  {
    count: "687",
    label: "Financial Services",
    stats: 10,
  },
  {
    count: "78",
    label: "Healthcare",
    stats: 10,
  },
  {
    count: "789",
    label: "Hi-Tech",
    stats: 10,
  },
  {
    count: "123",
    label: "Hospitality",
    stats: 10,
  },
  {
    count: "78",
    label: "Travel and Leisure",
    stats: 10,
  },
  {
    count: "687",
    label: "Insurance",
    stats: 10,
  },
  {
    count: "78",
    label: "Legal",
    stats: 10,
  },
  {
    count: "789",
    label: "Manufacturing",
    stats: 10,
  },
  {
    count: "123",
    label: "Media and Advertising",
    stats: 10,
  },
  {
    count: "78",
    label: "Non-Profit",
    stats: 10,
  },
  {
    count: "687",
    label: "Pharmaceutical and life Science",
    stats: 10,
  },
  {
    count: "78",
    label: "Politics",
    stats: 10,
  },
  {
    count: "789",
    label: "Professional Services",
    stats: 10,
  },
  {
    count: "123",
    label: "Public Services",
    stats: 10,
  },
  {
    count: "78",
    label: "Real Estate",
    stats: 10,
  },
  {
    count: "687",
    label: "Social Sciences and Development",
    stats: 10,
  },
  {
    count: "78",
    label: "Software",
    stats: 10,
  },
  {
    count: "789",
    label: "Sports and Fitness",
    stats: 10,
  },
  {
    count: "123",
    label: "Telecommunication",
    stats: 10,
  },
  {
    count: "78",
    label: "Transportation and Warehousing",
    stats: 10,
  },
  {
    count: "687",
    label: "Other",
    stats: 10,
  },
  {
    count: "78",
    label: "Software",
    stats: 10,
  },
];
const specializationArr = [
  {
    count: "5.1k",
    label: "Finance",
    stats: 10,
  },
  {
    count: "1.2k",
    label: "Financial Planning & Analysis",
    stats: 10,
  },
  {
    count: "1.3k",
    label: "Consumer Experience",
    stats: 10,
  },
  {
    count: "125",
    label: "Strategic Business Planning",
    stats: 10,
  },
  {
    count: "808",
    label: "Go-to-Market & Market Growth Strategy",
    stats: 10,
  },
  {
    count: "789",
    label: "Biology Health Care and Medicine",
    stats: 10,
  },
  {
    count: "123",
    label: "Brand and Marketing Strategy",
    stats: 10,
  },
  {
    count: "78",
    label: "Business Analysis",
    stats: 10,
  },
  {
    count: "687",
    label: "Business Process Redesign",
    stats: 10,
  },
  {
    count: "78",
    label: "Change Management",
    stats: 10,
  },
  {
    count: "789",
    label: "Chemistry",
    stats: 10,
  },
  {
    count: "123",
    label: "Consumer Experience",
    stats: 10,
  },
  {
    count: "78",
    label: "Customer Analytics",
    stats: 10,
  },
  {
    count: "687",
    label: "Due Diligence",
    stats: 10,
  },
  {
    count: "78",
    label: "Engineering and design",
    stats: 10,
  },
  {
    count: "789",
    label: "ManufacturingExploration and production",
    stats: 10,
  },
  {
    count: "123",
    label: "General Management Consulting",
    stats: 10,
  },
  {
    count: "78",
    label: "Human Resources",
    stats: 10,
  },
  {
    count: "687",
    label: "Managed Markets",
    stats: 10,
  },
  {
    count: "78",
    label: "Market Research",
    stats: 10,
  },
  {
    count: "789",
    label: "Marketing",
    stats: 10,
  },
  {
    count: "123",
    label: "Media and Advertising",
    stats: 10,
  },
  {
    count: "78",
    label: "Mergers and Acquisitions Strategy",
    stats: 10,
  },
  {
    count: "687",
    label: "Physical Science",
    stats: 10,
  },
  {
    count: "78",
    label: "Pricing and Actuarial",
    stats: 10,
  },
  {
    count: "789",
    label: "Project Management",
    stats: 10,
  },
  {
    count: "123",
    label: "R&D",
    stats: 10,
  },
  {
    count: "78",
    label: "Risk and Compliance",
    stats: 10,
  },
  {
    count: "687",
    label: "Sales",
    stats: 10,
  },
  {
    count: "78",
    label: "Security and Operations",
    stats: 10,
  },
  {
    count: "789",
    label: "Social Media",
    stats: 10,
  },
  {
    count: "123",
    label: "Social Sciences",
    stats: 10,
  },
  {
    count: "78",
    label: "Strategic Business Planning",
    stats: 10,
  },
  {
    count: "687",
    label: "Supply Chain and Logistics",
    stats: 10,
  },
  {
    count: "78",
    label: "Technical Writing",
    stats: 10,
  },
  {
    count: "789",
    label: "Voice of Customer Research",
    stats: 10,
  },
  {
    count: "123",
    label: "Other…",
    stats: 10,
  },
];
const TechnologyArr = [
  {
    count: "5.1k",
    label: "Big Data and Cloud",
    stats: 10,
  },
  {
    count: "1.2k",
    label: "Blockchain Technology",
    stats: 10,
  },
  {
    count: "1.3k",
    label: "Business Intelligence and Visualization",
    stats: 10,
  },
  {
    count: "125",
    label: "CRM",
    stats: 10,
  },
  {
    count: "808",
    label: "ERP",
    stats: 10,
  },
  {
    count: "789",
    label: "Accounting",
    stats: 10,
  },
  {
    count: "123",
    label: "Operations",
    stats: 10,
  },
  {
    count: "78",
    label: "Marketing Automation",
    stats: 10,
  },
  {
    count: "687",
    label: "Chatbot and Voice Assistant",
    stats: 10,
  },
  {
    count: "78",
    label: "Data analysis and AI Tools",
    stats: 10,
  },
  {
    count: "789",
    label: "Data analysis in Biology",
    stats: 10,
  },
  {
    count: "123",
    label: "Data Science",
    stats: 10,
  },
  {
    count: "78",
    label: "Data Warehouse Appliance",
    stats: 10,
  },
  {
    count: "687",
    label: "Design and Animation",
    stats: 10,
  },
  {
    count: "78",
    label: "DevOps Tools",
    stats: 10,
  },
  {
    count: "789",
    label: "Deep Learning",
    stats: 10,
  },
  {
    count: "123",
    label: "Appliances",
    stats: 10,
  },
  {
    count: "78",
    label: "Machine Learning Framework",
    stats: 10,
  },
  {
    count: "687",
    label: "Mapping and GIS",
    stats: 10,
  },
  {
    count: "78",
    label: "Master Data Management",
    stats: 10,
  },
  {
    count: "789",
    label: "Programming Languages and Framework",
    stats: 10,
  },
  {
    count: "123",
    label: "QA Tools",
    stats: 10,
  },
  {
    count: "78",
    label: "Reinforcement Learning",
    stats: 10,
  },
  {
    count: "687",
    label: "Robotics Process Automation (RPA)",
    stats: 10,
  },
  {
    count: "78",
    label: "Security Analytics",
    stats: 10,
  },
  {
    count: "789",
    label: "Web Analytics Platform",
    stats: 10,
  },
  {
    count: "123",
    label: "Other",
    stats: 10,
  },
];
const TechnicalArr = [
  {
    count: "789",
    label: "Analytics",
    stats: 10,
  },
  {
    count: "123",
    label: "Analytics Blockchain",
    stats: 10,
  },
  {
    count: "78",
    label: "Business Intelligence",
    stats: 10,
  },
  {
    count: "687",
    label: "Security Analytics",
    stats: 10,
  },
  {
    count: "78",
    label: "CRM",
    stats: 10,
  },
  {
    count: "789",
    label: "ERP",
    stats: 10,
  },
  {
    count: "123",
    label: "Accounting",
    stats: 10,
  },
  {
    count: "78",
    label: "Operations",
    stats: 10,
  },
  {
    count: "687",
    label: "Marketing Automation",
    stats: 10,
  },
  {
    count: "78",
    label: "Computational Biology",
    stats: 10,
  },
  {
    count: "789",
    label: "Data Engineering",
    stats: 10,
  },
  {
    count: "123",
    label: "Data Management",
    stats: 10,
  },
  {
    count: "78",
    label: "Data Visualization",
    stats: 10,
  },
  {
    count: "687",
    label: "Data Warehousing",
    stats: 10,
  },
  {
    count: "78",
    label: "Design",
    stats: 10,
  },
  {
    count: "789",
    label: "Devops",
    stats: 10,
  },
  {
    count: "123",
    label: "Enterprise Performance Management",
    stats: 10,
  },
  {
    count: "78",
    label: "Gaming analytics",
    stats: 10,
  },
  {
    count: "687",
    label: "Internet of things",
    stats: 10,
  },
  {
    count: "78",
    label: "Marketing and Web Analytics",
    stats: 10,
  },
  {
    count: "789",
    label: "Mobile Apps",
    stats: 10,
  },
  {
    count: "123",
    label: "Ontology and Semantic Technology",
    stats: 10,
  },
  {
    count: "78",
    label: "Quality Assurance",
    stats: 10,
  },
  {
    count: "687",
    label: "Robotics",
    stats: 10,
  },
  {
    count: "78",
    label: "Robotic Process Automation",
    stats: 10,
  },
  {
    count: "789",
    label: "Security Analytics",
    stats: 10,
  },
  {
    count: "123",
    label: "Software and Web Development",
    stats: 10,
  },
  {
    count: "78",
    label: "Speech and Voice Analytics",
    stats: 10,
  },
  {
    count: "687",
    label: "Other",
    stats: 10,
  },
];
const rangeData = [
  {
    day: "05-01",
    temperature: 2,
  },
  {
    day: "05-02",
    temperature: 4,
  },
  {
    day: "05-03",
    temperature: 3,
  },
  {
    day: "05-04",
    temperature: 5,
  },
  {
    day: "05-05",
    temperature: 4,
  },
  {
    day: "05-06",
    temperature: 5,
  },
  {
    day: "05-07",
    temperature: 12,
  },
  {
    day: "05-08",
    temperature: 11,
  },
  {
    day: "05-09",
    temperature: 13,
  },
  {
    day: "05-10",
    temperature: 11,
  },
  {
    day: "05-11",
    temperature: 7,
  },
  {
    day: "05-12",
    temperature: 7.5,
  },
  {
    day: "05-13",
    temperature: 14,
  },
  {
    day: "05-14",
    temperature: 14,
  },
  {
    day: "05-15",
    temperature: 17,
  },
  {
    day: "05-16",
    temperature: 18,
  },
  {
    day: "05-17",
    temperature: 17,
  },
  {
    day: "05-18",
    temperature: 15,
  },
  {
    day: "05-19",
    temperature: 15,
  },
  {
    day: "05-20",
    temperature: 17,
  },
  {
    day: "05-21",
    temperature: 15,
  },
  {
    day: "05-22",
    temperature: 14,
  },
  {
    day: "05-23",
    temperature: 16,
  },
  {
    day: "05-24",
    temperature: 17,
  },
  {
    day: "05-25",
    temperature: 18,
  },
];

const dropdownOptions = [
  "Demographics",
  "Industry",
  "Specializations and Business Functions",
  "Technology and Tools",
  "Technical Functions",
];
const filterOptions = [
  "Most Available Hours",
  "Least Available Hours",
  "Least Login",
  "Most Login",
  "Most Al Projects Completed",
  "Least Al Projects Completed",
  "Most Viewed Profile",
  "Least Viewed Profile",
];
const appliedFilters = (filter) => {
  if (filter === "Industry") {
    return industryArr;
  } else if (filter === "Demographics") {
    return demographicsArr;
  } else if (filter === "Specializations and Business Functions") {
    return specializationArr;
  }
  else if (filter === "Technology and Tools") {
    return TechnologyArr;
  }
  else if (filter === "Technical Functions") {
    return TechnicalArr;
  }

};

const NewAdmin = () => {
  const [openNewUserModal, setOpenNewUserModal] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dropdownOptions[0]);
  const [selectedOptionFilter, setSelectedFilter] = useState(filterOptions[0]);

  return (
    <DashboardLayout>
      <section className="px-6 pt-4 w-full bg-[#f9fafb]">
        <AddNewUserModal
          open={openNewUserModal}
          setOpen={setOpenNewUserModal}
          setOpenSuccess={setOpenSuccess}
        />
        <AddNewUserSuccess open={openSuccess} setOpen={setOpenSuccess} />
        <Breadcrumbs links={[{ name: "Admin", link: "/" }]} />
        <div className="flex items-center justify-between w-full mt-6">
          <div className="flex flex-col gap-y-1">
            <span className="text-2xl font-bold text-[#111928]">
              Welcome, John Doe
            </span>
            <span className="text-md text-[#6B7280]">
              Your current Statistics summary and activity.
            </span>
          </div>
          <div>
            <div className="flex items-stretch">
              <button className="border py-1.5 px-4 rounded-l-lg text-sm font-medium bg-[#f9fafb] text-[#6B7280]">
                This Year
              </button>
              <button className="border py-1.5 px-4 rounded-r-lg text-sm font-medium text-[#6B7280] bg-white">
                This Month
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-full mt-3">
          <div className="flex items-center gap-x-4">
            <div className="flex items-center ">
              <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[23rem]">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search"
                  className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
                />
              </div>
              <div>
                <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                  Search
                </button>
              </div>
            </div>
            <button className="w-[5.6rem] h-[2.3rem] flex items-center justify-center border-[1px] border-[#E5E7EB] rounded-[8px] gap-x-2">
              <img src={FilterICon} /> Filters
            </button>
          </div>

          <span className="flex items-center bg-white py-2 px-4 rounded-lg border ml-2">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.41421 9.91421C9.78929 9.53914 10 9.03043 10 8.5C10 7.96957 9.78929 7.46086 9.41421 7.08579C9.03914 6.71071 8.53043 6.5 8 6.5C7.46957 6.5 6.96086 6.71071 6.58579 7.08579C6.21071 7.46086 6 7.96957 6 8.5C6 9.03043 6.21071 9.53914 6.58579 9.91421C6.96086 10.2893 7.46957 10.5 8 10.5C8.53043 10.5 9.03914 10.2893 9.41421 9.91421Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.63672 8.49992C2.48605 5.79525 5.01338 3.83325 7.99805 3.83325C10.9834 3.83325 13.5101 5.79525 14.3594 8.49992C13.5101 11.2046 10.9834 13.1666 7.99805 13.1666C5.01338 13.1666 2.48605 11.2046 1.63672 8.49992Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-medium ml-1">View Al Projects</p>
          </span>
          <span className="flex items-center bg-white py-2 px-4 rounded-lg border">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.11667 3.378C8.83267 2.20733 7.16733 2.20733 6.88333 3.378C6.69933 4.13467 5.83267 4.49333 5.16867 4.088C4.13933 3.46133 2.962 4.63933 3.58867 5.668C3.68287 5.8225 3.73926 5.99706 3.75325 6.17748C3.76723 6.35789 3.73843 6.53906 3.66916 6.70623C3.5999 6.87341 3.49215 7.02187 3.35467 7.13953C3.21719 7.25719 3.05387 7.34072 2.878 7.38333C1.70733 7.66733 1.70733 9.33267 2.878 9.61667C3.05371 9.6594 3.21686 9.74298 3.35418 9.86063C3.49151 9.97828 3.59913 10.1267 3.66831 10.2937C3.7375 10.4608 3.76628 10.6419 3.75232 10.8222C3.73837 11.0024 3.68207 11.1769 3.588 11.3313C2.96133 12.3607 4.13933 13.538 5.168 12.9113C5.3225 12.8171 5.49706 12.7607 5.67748 12.7468C5.85789 12.7328 6.03906 12.7616 6.20623 12.8308C6.37341 12.9001 6.52187 13.0079 6.63953 13.1453C6.75719 13.2828 6.84072 13.4461 6.88333 13.622C7.16733 14.7927 8.83267 14.7927 9.11667 13.622C9.1594 13.4463 9.24298 13.2831 9.36063 13.1458C9.47828 13.0085 9.62667 12.9009 9.79375 12.8317C9.96082 12.7625 10.1419 12.7337 10.3222 12.7477C10.5024 12.7616 10.6769 12.8179 10.8313 12.912C11.8607 13.5387 13.038 12.3607 12.4113 11.332C12.3171 11.1775 12.2607 11.0029 12.2468 10.8225C12.2328 10.6421 12.2616 10.4609 12.3308 10.2938C12.4001 10.1266 12.5079 9.97813 12.6453 9.86047C12.7828 9.74281 12.9461 9.65928 13.122 9.61667C14.2927 9.33267 14.2927 7.66733 13.122 7.38333C12.9463 7.3406 12.7831 7.25702 12.6458 7.13937C12.5085 7.02172 12.4009 6.87333 12.3317 6.70625C12.2625 6.53918 12.2337 6.35814 12.2477 6.17785C12.2616 5.99756 12.3179 5.8231 12.412 5.66867C13.0387 4.63933 11.8607 3.462 10.832 4.08867C10.6775 4.18287 10.5029 4.23926 10.3225 4.25325C10.1421 4.26723 9.96094 4.23843 9.79377 4.16916C9.62659 4.0999 9.47813 3.99215 9.36047 3.85467C9.24281 3.71719 9.15928 3.55387 9.11667 3.378Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.41421 9.91421C9.78929 9.53914 10 9.03043 10 8.5C10 7.96957 9.78929 7.46086 9.41421 7.08579C9.03914 6.71071 8.53043 6.5 8 6.5C7.46957 6.5 6.96086 6.71071 6.58579 7.08579C6.21071 7.46086 6 7.96957 6 8.5C6 9.03043 6.21071 9.53914 6.58579 9.91421C6.96086 10.2893 7.46957 10.5 8 10.5C8.53043 10.5 9.03914 10.2893 9.41421 9.91421Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-medium ml-1">
              Manage Generative AI Index
            </p>
          </span>
          <span className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">
              Assign AI team
            </p>
          </span>
          <span
            className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg cursor-pointer"
            onClick={() => setOpenNewUserModal(true)}
          >
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">Add New User</p>
          </span>
        </div>

        <main className="mt-6">
          <div>
            <span className="text-gray-800 text-md font-semibold ml-0.5">
              User Statistics
            </span>
            <div className="grid grid-cols-3 gap-4 mt-3">
              <div className="flex flex-col items-start justify-between border rounded-lg p-4 pb-0 w-full bg-white">
                <div className="flex items-center justify-between w-full">
                  <span className="text-ms font-medium">All time users</span>
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99999C10.8332 9.53976 10.4601 9.16666 9.99984 9.16666C9.5396 9.16666 9.1665 9.53976 9.1665 9.99999C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 4.99999C10.4601 4.99999 10.8332 4.6269 10.8332 4.16666C10.8332 3.70642 10.4601 3.33333 9.99984 3.33333C9.5396 3.33333 9.1665 3.70642 9.1665 4.16666C9.1665 4.6269 9.5396 4.99999 9.99984 4.99999Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 16.6667C10.4601 16.6667 10.8332 16.2936 10.8332 15.8333C10.8332 15.3731 10.4601 15 9.99984 15C9.5396 15 9.1665 15.3731 9.1665 15.8333C9.1665 16.2936 9.5396 16.6667 9.99984 16.6667Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="flex items-start justify-between mt-3 gap-x-4 w-full">
                  <div className="flex flex-col items-start w-[50%]">
                    <span className="text-3xl font-extrabold text-[#111928]">
                      2,420
                    </span>
                    <div className="flex items-center mt-2">
                      <span className="flex items-center gap-x-0.5 text-[0.875rem] text-[#0E9F6E] font-extra-bold">
                        <svg
                          width={14}
                          height={13}
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                            fill="#0E9F6E"
                            stroke="#0E9F6E"
                          />
                        </svg>
                        40%
                      </span>
                      <p className="ml-1.5 text-gray-600 text-[0.875rem] font-medium">
                        vs last month
                      </p>
                    </div>
                  </div>
                  <div className="w-[50%] h-[5.5rem]">
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        data={rangeData}
                        margin={{
                          top: 20,
                          right: 20,
                          bottom: 20,
                          left: 20,
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="colorUv"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                          >
                            <stop
                              offset="2%"
                              stopColor="#ECFDF3"
                              stopOpacity={0.6}
                            />
                            <stop
                              offset="70%"
                              stopColor="#ECFDF3"
                              stopOpacity={0.2}
                            />
                          </linearGradient>
                        </defs>
                        <Area
                          type="basisOpen"
                          dataKey="temperature"
                          fillOpacity={1}
                          strokeWidth={2}
                          stroke="#17B26A"
                          fill="url(#colorUv)"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-start justify-between border rounded-lg p-4 pb-0 w-full bg-white">
                <div className="flex items-center justify-between w-full">
                  <span className="text-ms font-medium">This month</span>
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99999C10.8332 9.53976 10.4601 9.16666 9.99984 9.16666C9.5396 9.16666 9.1665 9.53976 9.1665 9.99999C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 4.99999C10.4601 4.99999 10.8332 4.6269 10.8332 4.16666C10.8332 3.70642 10.4601 3.33333 9.99984 3.33333C9.5396 3.33333 9.1665 3.70642 9.1665 4.16666C9.1665 4.6269 9.5396 4.99999 9.99984 4.99999Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 16.6667C10.4601 16.6667 10.8332 16.2936 10.8332 15.8333C10.8332 15.3731 10.4601 15 9.99984 15C9.5396 15 9.1665 15.3731 9.1665 15.8333C9.1665 16.2936 9.5396 16.6667 9.99984 16.6667Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="flex items-start justify-between mt-3 gap-x-4 w-full">
                  <div className="flex flex-col items-start w-[50%]">
                    <span className="text-3xl font-extrabold text-[#111928]">
                      1,210
                    </span>
                    <div className="flex items-center mt-2">
                      <span className="flex items-center gap-x-0.5 text-[0.875rem] text-[#B42318] font-extra-bold">
                        <svg
                          width={14}
                          height={13}
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="rotate-180	"
                        >
                          <path
                            d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                            fill="#B42318"
                            stroke="#B42318"
                          />
                        </svg>
                        10%
                      </span>
                      <p className="ml-1.5 text-gray-600 text-[0.875rem] font-medium">
                        vs last month
                      </p>
                    </div>
                  </div>
                  <div className="w-[50%] h-[5.5rem]">
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        data={[...rangeData]?.reverse()}
                        margin={{
                          top: 20,
                          right: 20,
                          bottom: 20,
                          left: 20,
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="colorUv2"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                          >
                            <stop
                              offset="2%"
                              stopColor="#FEF3F2"
                              stopOpacity={0.4}
                            />
                            <stop
                              offset="70%"
                              stopColor="#FEF3F2"
                              stopOpacity={0.2}
                            />
                          </linearGradient>
                        </defs>
                        <Area
                          type="basisOpen"
                          dataKey="temperature"
                          fillOpacity={1}
                          strokeWidth={2}
                          stroke="#F04438"
                          fill="url(#colorUv2)"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-start justify-between border rounded-lg p-4 pb-0 w-full bg-white">
                <div className="flex items-center justify-between w-full">
                  <span className="text-ms font-medium">Active Users</span>
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99984 10.8333C10.4601 10.8333 10.8332 10.4602 10.8332 9.99999C10.8332 9.53976 10.4601 9.16666 9.99984 9.16666C9.5396 9.16666 9.1665 9.53976 9.1665 9.99999C9.1665 10.4602 9.5396 10.8333 9.99984 10.8333Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 4.99999C10.4601 4.99999 10.8332 4.6269 10.8332 4.16666C10.8332 3.70642 10.4601 3.33333 9.99984 3.33333C9.5396 3.33333 9.1665 3.70642 9.1665 4.16666C9.1665 4.6269 9.5396 4.99999 9.99984 4.99999Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99984 16.6667C10.4601 16.6667 10.8332 16.2936 10.8332 15.8333C10.8332 15.3731 10.4601 15 9.99984 15C9.5396 15 9.1665 15.3731 9.1665 15.8333C9.1665 16.2936 9.5396 16.6667 9.99984 16.6667Z"
                      stroke="#98A2B3"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="flex items-start justify-between mt-3 gap-x-4 w-full">
                  <div className="flex flex-col items-start w-[50%]">
                    <span className="text-3xl font-extrabold text-[#111928]">
                      316
                    </span>
                    <div className="flex items-center mt-2">
                      <span className="flex items-center gap-x-0.5 text-[0.875rem] text-[#0E9F6E] font-extra-bold">
                        <svg
                          width={14}
                          height={13}
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                            fill="#0E9F6E"
                            stroke="#0E9F6E"
                          />
                        </svg>
                        20%
                      </span>
                      <p className="ml-1.5 text-gray-600 text-[0.875rem] font-medium">
                        vs last month
                      </p>
                    </div>
                  </div>
                  <div className="w-[50%] h-[5.5rem]">
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        data={rangeData}
                        margin={{
                          top: 20,
                          right: 20,
                          bottom: 20,
                          left: 20,
                        }}
                      >
                        <defs>
                          <linearGradient
                            id="colorUv"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                          >
                            <stop
                              offset="2%"
                              stopColor="#ECFDF3"
                              stopOpacity={0.6}
                            />
                            <stop
                              offset="70%"
                              stopColor="#ECFDF3"
                              stopOpacity={0.2}
                            />
                          </linearGradient>
                        </defs>
                        <Area
                          type="basisOpen"
                          dataKey="temperature"
                          fillOpacity={1}
                          strokeWidth={2}
                          stroke="#17B26A"
                          fill="url(#colorUv)"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <main className="mt-6">
          <div>
            <span className="text-gray-800 text-md font-semibold ml-0.5">
              Overview
            </span>
            <div className="flex gap-x-3 mt-3">
              <AdminDropDown
                options={dropdownOptions}
                width="21rem"
                selected={selectedOption}
                setSelected={setSelectedOption}
              />
              <AdminDropDown
                options={filterOptions}
                width="13rem"
                selected={selectedOptionFilter}
                setSelected={setSelectedFilter}
              />
            </div>
            <div className="grid grid-cols-4 gap-4 mt-3">
              {appliedFilters(selectedOption)?.map((item) => (
                <div className="flex items-center justify-between border rounded-lg p-4 w-full bg-white">
                  <div className="flex flex-col items-start">
                    <span className="text-3xl font-extrabold text-[#111928]">
                      {item.count}
                    </span>
                    <span className="text-sm text-[#6B7280]">{item.label}</span>
                  </div>
                  <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                    {item.stats}%
                    <svg
                      width={15}
                      height={14}
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="ml-0.5"
                    >
                      <path
                        d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                        fill="#0E9F6E"
                        stroke="#0E9F6E"
                      />
                    </svg>
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-6">
              <div className="grid grid-cols-2 gap-x-3">
                <div className="rounded-lg p-4 shadow w-full bg-white">
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col items-start">
                      <span className="text-3xl font-extrabold text-[#111928]">
                        13 weeks
                      </span>
                      <span className="text-md text-[#6B7280]">
                        Average project completion time per team
                      </span>
                    </div>
                    <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                      10%
                      <svg
                        width={15}
                        height={14}
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="ml-0.5"
                      >
                        <path
                          d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                          fill="#0E9F6E"
                          stroke="#0E9F6E"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="flex flex-col divide-y-2 gap-y-3 mt-6">
                    <div className="w-full h-[25rem]">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartOneData} barSize={40}>
                          <Bar
                            dataKey="Number of Weeks"
                            fill="#942A27"
                            background={{ fill: "#E5E7EB" }}
                            radius={8}
                          />
                          <Tooltip cursor={false} />
                          <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="flex items-center justify-between pt-6">
                      <select value="10" className="bg-inherit">
                        <option value="10">Last 7 months</option>
                      </select>
                      <button className="text-[#942A27] flex items-center">
                        Team Performance Report
                        <svg
                          width={21}
                          height={21}
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-1"
                        >
                          <path
                            d="M8.16797 4.71069L14.0013 10.544L8.16797 16.3774"
                            stroke="#942A27"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg p-4 shadow w-full bg-white">
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col items-start">
                      <span className="text-3xl font-extrabold text-[#111928]">
                        80%
                      </span>
                      <span className="text-md text-[#6B7280]">
                        Average Team Workload - Percentage of their capacity
                        being utilized per week
                      </span>
                    </div>
                    <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                      4,6%
                      <svg
                        width={15}
                        height={14}
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="ml-0.5"
                      >
                        <path
                          d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                          fill="#0E9F6E"
                          stroke="#0E9F6E"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="flex flex-col divide-y-2 gap-y-3 mt-6">
                    <div className="w-full h-[25rem]">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartTwoData}>
                          <Bar dataKey="Workload" fill="#942A27" radius={8} />
                          <Tooltip
                            cursor={false}
                            content={({ active, payload, label }) => {
                              console.log(active, payload, label);
                              return (
                                <div className="flex flex-col items-start gap-y-1 py-4 px-3 bg-white border-2">
                                  {label}
                                  <span
                                    className="text-sm font-medium"
                                    style={{
                                      color: payload[0]?.color
                                        ? payload[0]?.color
                                        : "black",
                                    }}
                                  >
                                    {`${payload[0]?.name} : ${payload[0]?.value}%`}
                                  </span>
                                </div>
                              );
                            }}
                          />
                          <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            // style={{ display: "none" }}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="flex items-center justify-between pt-6">
                      <select value="10" className="bg-inherit">
                        <option value="10">Last 7 months</option>
                      </select>
                      <button className="text-[#942A27] flex items-center">
                        Change to Team Workload Report
                        <svg
                          width={21}
                          height={21}
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-1"
                        >
                          <path
                            d="M8.16797 4.71069L14.0013 10.544L8.16797 16.3774"
                            stroke="#942A27"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <span className="text-[#6B7280] text-md">Recent Activities</span>
            <AdminTable />
          </div>
        </main>
      </section>
    </DashboardLayout>
  );
};

export default NewAdmin;
